import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = {
  key: 0,
  class: "livebox"
}
const _hoisted_3 = { class: "hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress = _resolveComponent("vue3-progress")!
  const _component_VueLive = _resolveComponent("VueLive")!
  const _component_v_points = _resolveComponent("v-points")!
  const _component_v_circle = _resolveComponent("v-circle")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_surface = _resolveComponent("v-surface")!
  const _component_github_corners = _resolveComponent("github-corners")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue3_progress),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          true
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Vue Skia", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "description" }, [
                  _createTextVNode(" The "),
                  _createElementVNode("em", null, "vue-skia"),
                  _createTextVNode(" is a skia-based 2d graphics vue rendering library. It is based on Rust to implement software rasterization to perform rendering. It takes up less memory than the native canvas, however it is still a experiment project. And it's based entirely on vue syntax. ")
                ], -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "description" }, [
                  _createTextVNode(" This super cool editor is based on "),
                  _createElementVNode("em", null, "vue-live"),
                  _createTextVNode(" ! ")
                ], -1)),
                (!_ctx.debug)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _cache[2] || (_cache[2] = _createTextVNode(" You can edit ")),
                        _createElementVNode("span", {
                          title: "copy code to clipboard",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
                        }, "this"),
                        _cache[3] || (_cache[3] = _createElementVNode("span", null, "->", -1))
                      ]),
                      _createVNode(_component_VueLive, {
                        editorProps: { lineNumbers: true },
                        delay: 600,
                        code: !_ctx.loading && !_ctx.debug ? _ctx.code : _ctx.LoadingCode,
                        layout: _ctx.CustomLayout,
                        components: {
            VSurface: _ctx.VSurface,
            VGroup: _ctx.VGroup,
            VRect: _ctx.VRect,
            VCircle: _ctx.VCircle,
            VRoundRect: _ctx.VRoundRect,
            VLine: _ctx.VLine,
            VPoints: _ctx.VPoints,
            VImage: _ctx.VImage,
            VText: _ctx.VText,
          },
                        onError: _cache[1] || (_cache[1] = (e) => void 0),
                        onInput: _ctx.input
                      }, null, 8, ["code", "layout", "components", "onInput"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.debug)
            ? (_openBlock(), _createBlock(_component_v_surface, {
                key: 1,
                width: 400,
                height: 400
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_points, {
                    points: [
            [128, 0],
            [168, 80],
            [256, 93],
            [192, 155],
            [207, 244],
            [128, 202],
            [49, 244],
            [64, 155],
            [0, 93],
            [88, 80],
          ],
                    style: 'fill',
                    strokeWidth: 1,
                    color: 'rgba(200, 255, 0, 1)'
                  }),
                  _createVNode(_component_v_circle, {
                    cx: 200,
                    cy: 260,
                    r: 80,
                    style: 'stroke',
                    color: "#ee22ee"
                  }),
                  _createVNode(_component_v_rect, {
                    x: 10,
                    y: 220,
                    width: 30,
                    height: 30,
                    color: "#00aaff",
                    style: 'fill'
                  }),
                  _createVNode(_component_v_image, {
                    x: 30,
                    y: 40,
                    image: 'https://raw.githubusercontent.com/rustq/vue-skia/main/vue-playground/src/assets/logo.png',
                    width: 70,
                    height: 70,
                    blur: 10,
                    grayscale: false,
                    brighten: 80,
                    invert: false
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_github_corners, {
            href: "https://github.com/rustq/vue-skia",
            gitColor: "#FFFFFF"
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}